@if(loading){
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
} @else {
  <div class="info-screen-container">
    <app-info-screen
      [title]="copy.title"
      [highlightedText]="copy.highlightedText"
      [description]="copy.description"
      [listItems]="[]"
      [buttonText]="copy.buttonText"
      (buttonClicked)="handleButtonClick()"
      [contactLink]="'/help'"
      [steps]="copy.steps"
    ></app-info-screen>
    @if(showSuccess){
      <div class="success-overlay">
        <div class="success-content">
          <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem"></i>
          <p class="mt-3 fs-5">{{ copy.consentSignedMessage }}</p>
          <p class="mt-4">{{ copy.redirectingMessage }}</p>
        </div>
      </div>
    }
  </div>
}
